import { isChainSolana } from '@/constants/index'

export const MINIMUM_NATIVE_FUNDS = isChainSolana() ? {
  symbol: 'SOL',
  amount: 0.001,
} : {
  symbol: 'RENEC',
  amount: 0.1,
}
